import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

const signatureAbayas = [
  {
    id: 1,
    name: 'Midnight Elegance Abaya',
    price: '$189.00',
    image: 'https://public.readdy.ai/ai/img_res/41197d967789cba80cd72a7b1c57b934.jpg',
    colors: ['#000000', '#1a3a2a', '#374151'],
    badge: 'Premium',
  },
  {
    id: 2,
    name: 'Emerald Grace Abaya',
    price: '$215.00',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20emerald%20green%20abaya%20with%20pearl%20beading%20along%20neckline%20and%20cuffs%20displayed%20on%20a%20faceless%20headless%20mannequin%20soft%20cream%20studio%20background%20rich%20flowing%20fabric%20with%20subtle%20sheen%20modest%20islamic%20haute%20couture%20professional%20fashion%20photography%20emphasizing%20craftsmanship%20and%20premium%20quality%20no%20face%20no%20head&width=600&height=800&seq=abaya012&orientation=portrait',
    colors: ['#065f46', '#0f766e'],
    badge: 'Premium',
  },
  {
    id: 3,
    name: 'Royal Navy Abaya',
    price: '$199.00',
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20navy%20blue%20abaya%20with%20intricate%20gold%20thread%20embroidery%20patterns%20displayed%20on%20a%20headless%20faceless%20dress%20form%20mannequin%20cream%20background%20luxurious%20premium%20fabric%20with%20perfect%20drape%20modest%20islamic%20designer%20wear%20professional%20studio%20product%20photography%20highlighting%20detailed%20craftsmanship%20no%20face%20no%20person&width=600&height=800&seq=abaya013&orientation=portrait',
    colors: ['#1e3a5f', '#312e81', '#000000'],
    badge: 'Premium',
  },
];

const banglesBeads = [
  {
    id: 1,
    name: 'Golden Heritage Bangles',
    price: '$89.00',
    image: 'https://readdy.ai/api/search-image?query=elegant%20gold%20bangles%20set%20with%20intricate%20traditional%20islamic%20geometric%20patterns%20and%20delicate%20beadwork%20displayed%20on%20soft%20cream%20velvet%20cushion%20luxurious%20jewelry%20photography%20warm%20lighting%20highlighting%20craftsmanship%20details%20and%20metallic%20sheen%20professional%20product%20shot&width=500&height=500&seq=bangle001&orientation=squarish',
  },
  {
    id: 2,
    name: 'Emerald Bead Bracelet',
    price: '$45.00',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20emerald%20green%20and%20gold%20beaded%20bracelet%20with%20traditional%20islamic%20design%20elements%20arranged%20elegantly%20on%20cream%20silk%20fabric%20close%20up%20jewelry%20photography%20showing%20intricate%20bead%20details%20and%20color%20combinations%20luxurious%20handcrafted%20accessories%20professional%20studio%20lighting&width=500&height=500&seq=bead001&orientation=squarish',
  },
  {
    id: 3,
    name: 'Pearl Filigree Bangles',
    price: '$125.00',
    image: 'https://readdy.ai/api/search-image?query=ornate%20gold%20and%20pearl%20bangles%20set%20with%20traditional%20middle%20eastern%20filigree%20work%20displayed%20on%20elegant%20cream%20background%20luxurious%20bridal%20jewelry%20close%20up%20photography%20highlighting%20pearl%20details%20and%20gold%20craftsmanship%20professional%20product%20photography%20soft%20lighting&width=500&height=500&seq=bangle002&orientation=squarish',
  },
  {
    id: 4,
    name: 'Traditional Prayer Beads',
    price: '$35.00',
    image: 'https://readdy.ai/api/search-image?query=colorful%20traditional%20islamic%20prayer%20beads%20tasbih%20with%20gold%20accents%20and%20emerald%20green%20beads%20arranged%20beautifully%20on%20cream%20silk%20fabric%20detailed%20jewelry%20photography%20showing%20craftsmanship%20and%20bead%20texture%20spiritual%20accessories%20professional%20studio%20shot%20warm%20lighting&width=500&height=500&seq=bead002&orientation=squarish',
  },
  {
    id: 5,
    name: 'Rose Gold Engraved Bangles',
    price: '$95.00',
    image: 'https://readdy.ai/api/search-image?query=elegant%20rose%20gold%20bangles%20with%20delicate%20engraving%20and%20small%20gemstone%20accents%20stacked%20beautifully%20on%20cream%20velvet%20display%20modern%20islamic%20jewelry%20design%20close%20up%20product%20photography%20highlighting%20metalwork%20details%20and%20shine%20professional%20studio%20lighting&width=500&height=500&seq=bangle003&orientation=squarish',
  },
  {
    id: 6,
    name: 'Multi-Strand Bead Necklace',
    price: '$68.00',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20multi%20strand%20beaded%20necklace%20with%20gold%20emerald%20and%20cream%20colored%20beads%20in%20traditional%20islamic%20style%20displayed%20on%20soft%20cream%20silk%20detailed%20jewelry%20photography%20showing%20bead%20arrangement%20and%20craftsmanship%20elegant%20handmade%20accessories%20professional%20product%20shot&width=500&height=500&seq=bead003&orientation=squarish',
  },
  {
    id: 7,
    name: 'Calligraphy Bangles',
    price: '$110.00',
    image: 'https://readdy.ai/api/search-image?query=antique%20gold%20finish%20bangles%20with%20traditional%20arabic%20calligraphy%20engravings%20and%20ornate%20patterns%20arranged%20on%20cream%20velvet%20cushion%20vintage%20inspired%20islamic%20jewelry%20detailed%20product%20photography%20showing%20texture%20and%20patina%20professional%20studio%20lighting%20highlighting%20craftsmanship&width=500&height=500&seq=bangle004&orientation=squarish',
  },
  {
    id: 8,
    name: 'Crystal Geometric Bracelet',
    price: '$52.00',
    image: 'https://readdy.ai/api/search-image?query=delicate%20crystal%20and%20gold%20beaded%20bracelet%20with%20emerald%20accents%20in%20islamic%20geometric%20pattern%20displayed%20on%20cream%20silk%20fabric%20elegant%20jewelry%20close%20up%20photography%20showing%20sparkle%20and%20bead%20details%20modern%20modest%20accessories%20professional%20product%20photography%20soft%20lighting&width=500&height=500&seq=bead004&orientation=squarish',
  },
];

const girlsWear = [
  {
    id: 1,
    name: 'Little Princess Abaya Set',
    age: 'Ages 4-8 years',
    price: '$75.00',
    badge: 'New Arrival',
    image: 'https://readdy.ai/api/search-image?query=adorable%20young%20muslim%20girl%20wearing%20elegant%20pink%20and%20gold%20embroidered%20abaya%20dress%20with%20matching%20hijab%20standing%20in%20soft%20cream%20studio%20setting%20joyful%20expression%20modest%20children%20islamic%20fashion%20professional%20photography%20highlighting%20delicate%20embroidery%20details%20and%20comfortable%20design&width=600&height=800&seq=girls001&orientation=portrait',
  },
  {
    id: 2,
    name: 'Emerald Dreams Dress',
    age: 'Ages 6-10 years',
    price: '$68.00',
    badge: 'New Arrival',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20young%20girl%20in%20elegant%20emerald%20green%20modest%20dress%20with%20gold%20trim%20and%20coordinating%20headscarf%20soft%20cream%20background%20smiling%20cheerfully%20traditional%20islamic%20children%20clothing%20professional%20fashion%20photography%20showing%20fabric%20quality%20and%20comfortable%20fit&width=600&height=800&seq=girls002&orientation=portrait',
  },
  {
    id: 3,
    name: 'Golden Blossom Ensemble',
    age: 'Ages 5-9 years',
    price: '$82.00',
    badge: 'New Arrival',
    image: 'https://readdy.ai/api/search-image?query=sweet%20young%20muslim%20girl%20wearing%20cream%20and%20gold%20embellished%20modest%20outfit%20with%20delicate%20beadwork%20and%20matching%20hijab%20soft%20studio%20lighting%20cream%20background%20happy%20expression%20children%20islamic%20formal%20wear%20professional%20product%20photography%20emphasizing%20elegant%20details&width=600&height=800&seq=girls003&orientation=portrait',
  },
];

const readyToShip = [
  {
    id: 1,
    name: 'Classic Black Abaya',
    price: '$165.00',
    image: 'https://readdy.ai/api/search-image?query=elegant%20classic%20black%20abaya%20with%20simple%20clean%20lines%20displayed%20on%20white%20background%20premium%20flowing%20fabric%20modest%20islamic%20fashion%20professional%20product%20photography%20studio%20shot%20highlighting%20quality%20and%20drape%20ready%20to%20ship%20inventory&width=500&height=700&seq=ready001&orientation=portrait',
  },
  {
    id: 2,
    name: 'Navy Embroidered Abaya',
    price: '$185.00',
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20navy%20blue%20abaya%20with%20subtle%20gold%20embroidery%20on%20white%20background%20luxurious%20fabric%20with%20elegant%20drape%20modest%20wear%20professional%20product%20photography%20clean%20studio%20shot%20in%20stock%20ready%20for%20immediate%20shipping&width=500&height=700&seq=ready002&orientation=portrait',
  },
  {
    id: 3,
    name: 'Charcoal Grey Abaya',
    price: '$175.00',
    image: 'https://readdy.ai/api/search-image?query=modern%20charcoal%20grey%20abaya%20with%20minimalist%20design%20on%20white%20background%20high%20quality%20fabric%20with%20beautiful%20flow%20contemporary%20modest%20fashion%20professional%20product%20photography%20studio%20lighting%20available%20in%20stock&width=500&height=700&seq=ready003&orientation=portrait',
  },
  {
    id: 4,
    name: 'Burgundy Silk Abaya',
    price: '$195.00',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20burgundy%20silk%20abaya%20with%20rich%20color%20and%20elegant%20silhouette%20white%20background%20premium%20fabric%20with%20lustrous%20sheen%20modest%20islamic%20haute%20couture%20professional%20product%20photography%20ready%20to%20ship%20immediately&width=500&height=700&seq=ready004&orientation=portrait',
  },
  {
    id: 5,
    name: 'Olive Green Abaya',
    price: '$170.00',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20olive%20green%20abaya%20with%20contemporary%20cut%20on%20white%20background%20soft%20flowing%20fabric%20modern%20modest%20wear%20professional%20product%20photography%20clean%20studio%20shot%20in%20hand%20ready%20for%20dispatch&width=500&height=700&seq=ready005&orientation=portrait',
  },
];

const HomePage = () => {
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [wishlist, setWishlist] = useState<number[]>([]);
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterStatus, setNewsletterStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const carouselRef = useRef<HTMLDivElement>(null);

  const toggleWishlist = (id: number) => {
    setWishlist(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
  };

  const visibleCount = 3;
  const maxIndex = readyToShip.length - visibleCount;

  const prevSlide = () => setCarouselIndex(i => Math.max(0, i - 1));
  const nextSlide = () => setCarouselIndex(i => Math.min(maxIndex, i + 1));

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newsletterEmail) return;
    try {
      const body = new URLSearchParams();
      body.append('email', newsletterEmail);
      const res = await fetch('https://readdy.ai/api/form/d6h8hs4thj2bbt0jp87g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setNewsletterStatus('success');
        setNewsletterEmail('');
      } else {
        setNewsletterStatus('error');
      }
    } catch {
      setNewsletterStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* ── HERO ── */}
      <section className="relative min-h-screen w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            alt="Elegant Premium Abaya"
            className="w-full h-full object-cover object-top"
            src="https://readdy.ai/api/search-image?query=elegant%20woman%20seen%20from%20behind%20wearing%20luxurious%20flowing%20premium%20black%20abaya%20with%20intricate%20gold%20embroidery%20details%20standing%20in%20minimalist%20modern%20interior%20with%20soft%20natural%20window%20light%20creating%20gentle%20shadows%20on%20rich%20fabric%20texture%20sophisticated%20modest%20fashion%20photography%20deep%20emerald%20and%20cream%20tones%20no%20face%20visible%20back%20view%20graceful%20silhouette%20professional%20high%20end%20boutique%20style&width=1920&height=1080&seq=hero002&orientation=landscape"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-emerald-900/40 via-emerald-900/30 to-black/50"></div>
        </div>
        <div className="relative z-10 flex items-center min-h-screen px-6 md:px-12 lg:px-20">
          <div className="max-w-7xl mx-auto w-full">
            <div className="max-w-2xl">
              <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-amber-50 mb-6 leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Elegant Modesty,<br /><span className="text-amber-200">Redefined</span>
              </h1>
              <p className="text-xl md:text-2xl text-amber-200 mb-10 font-light italic">
                Handcrafted Excellence for the Modern Muslimah
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/clothing"
                  className="inline-flex items-center justify-center px-8 py-4 bg-amber-500 text-amber-950 rounded-full font-medium text-lg hover:bg-amber-400 transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
                >
                  Explore Collection
                </Link>
                <Link
                  to="/products"
                  className="inline-flex items-center justify-center px-8 py-4 border-2 border-amber-500 text-amber-100 rounded-full font-medium text-lg hover:bg-amber-500/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Shop Ready-to-Ship <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-amber-50 to-transparent z-10"></div>
      </section>

      {/* ── SIGNATURE ABAYAS ── */}
      <section className="py-20 px-6 md:px-12 lg:px-20 bg-amber-50">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <div className="flex items-center mb-4">
              <div className="w-12 h-0.5 bg-amber-500 mr-4"></div>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl text-emerald-900 mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Signature Abayas
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl">
              Discover our exclusive collection of premium Abayas, where traditional elegance meets contemporary design. Each piece is crafted with meticulous attention to detail.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop="true">
            {signatureAbayas.map(product => (
              <div key={product.id} className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-2xl bg-white shadow-lg hover:shadow-2xl transition-all duration-300 mb-4">
                  <div className="aspect-[3/4] overflow-hidden">
                    <img
                      alt={product.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      src={product.image}
                    />
                  </div>
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 bg-amber-500 text-amber-950 text-sm font-medium rounded-full">{product.badge}</span>
                  </div>
                  <div className="absolute top-4 right-4">
                    <button
                      onClick={() => toggleWishlist(product.id)}
                      className="w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-md hover:bg-amber-50 transition-colors cursor-pointer"
                    >
                      <i className={`${wishlist.includes(product.id) ? 'ri-heart-fill text-red-500' : 'ri-heart-line text-gray-700'}`}></i>
                    </button>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-8">
                    <Link to={`/product/${product.id}`} className="px-6 py-3 bg-amber-500 text-amber-950 rounded-full font-medium hover:bg-amber-400 transition-colors whitespace-nowrap cursor-pointer">
                      Quick View
                    </Link>
                  </div>
                </div>
                <div className="px-2">
                  <h3 className="text-lg font-medium text-emerald-900 mb-2">{product.name}</h3>
                  <p className="text-2xl font-bold text-amber-600 mb-2">{product.price}</p>
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-600">Available in:</span>
                    <div className="flex gap-1">
                      {product.colors.map(c => (
                        <div key={c} className="w-5 h-5 rounded-full border-2 border-gray-300 cursor-pointer" style={{ backgroundColor: c }}></div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <Link
              to="/clothing"
              className="inline-flex items-center px-8 py-4 bg-emerald-900 text-amber-100 rounded-full font-medium text-lg hover:bg-emerald-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Explore All Abayas <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* ── BANGLES & BEADS ── */}
      <section className="py-20 px-6 md:px-12 lg:px-20 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-serif text-4xl md:text-5xl text-emerald-900 mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Handcrafted Bangles &amp; Beads
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Exquisite handcrafted jewelry that celebrates tradition and artistry. Each piece tells a story of heritage and craftsmanship.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop="true">
            {banglesBeads.map(item => (
              <div key={item.id} className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-xl bg-gray-50 mb-4">
                  <div className="aspect-square overflow-hidden">
                    <img
                      alt={item.name}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                      src={item.image}
                    />
                  </div>
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 bg-amber-500 text-amber-950 text-xs font-medium rounded-full">Handcrafted</span>
                  </div>
                  <div className="absolute top-3 right-3">
                    <button className="w-9 h-9 flex items-center justify-center bg-white rounded-full shadow-md hover:bg-amber-50 transition-colors cursor-pointer">
                      <i className="ri-heart-line text-gray-700 text-sm"></i>
                    </button>
                  </div>
                </div>
                <div>
                  <h3 className="text-base font-medium text-emerald-900 mb-1">{item.name}</h3>
                  <p className="text-xl font-bold text-amber-600">{item.price}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <Link
              to="/accessories"
              className="inline-flex items-center px-8 py-4 bg-amber-500 text-amber-950 rounded-full font-medium text-lg hover:bg-amber-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View All Accessories <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* ── GIRLS' CULTURAL WEAR ── */}
      <section className="py-20 px-6 md:px-12 lg:px-20 bg-gradient-to-br from-amber-50 via-rose-50 to-amber-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-serif text-4xl md:text-5xl text-emerald-900 mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Girls' Cultural Wear
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Beautiful modest wear for young girls, designed with care to celebrate tradition while ensuring comfort and style for the next generation.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop="true">
            {girlsWear.map(item => (
              <div key={item.id} className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-2xl bg-white shadow-lg hover:shadow-2xl transition-all duration-300 mb-4">
                  <div className="aspect-[3/4] overflow-hidden">
                    <img
                      alt={item.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      src={item.image}
                    />
                  </div>
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 bg-rose-400 text-white text-sm font-medium rounded-full">{item.badge}</span>
                  </div>
                  <div className="absolute top-4 right-4">
                    <button className="w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-md hover:bg-rose-50 transition-colors cursor-pointer">
                      <i className="ri-heart-line text-gray-700"></i>
                    </button>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-8">
                    <button className="px-6 py-3 bg-amber-500 text-amber-950 rounded-full font-medium hover:bg-amber-400 transition-colors whitespace-nowrap cursor-pointer">
                      Quick View
                    </button>
                  </div>
                </div>
                <div className="px-2">
                  <h3 className="text-lg font-medium text-emerald-900 mb-2">{item.name}</h3>
                  <p className="text-sm text-gray-600 mb-2">{item.age}</p>
                  <p className="text-2xl font-bold text-amber-600">{item.price}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <Link
              to="/themes"
              className="inline-flex items-center px-8 py-4 bg-rose-400 text-white rounded-full font-medium text-lg hover:bg-rose-500 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Shop Girls Collection <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* ── IN-HAND READY TO SHIP ── */}
      <section className="py-20 px-6 md:px-12 lg:px-20 bg-emerald-900">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-5 gap-12 items-center">
            <div className="lg:col-span-2">
              <h2 className="font-serif text-4xl md:text-5xl text-amber-50 mb-6 leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                In-Hand &amp;<br />Ready to Ship
              </h2>
              <p className="text-lg text-amber-200 mb-8">
                No waiting. Premium Abayas available for immediate delivery. Order today and receive your elegant piece within days.
              </p>
              <div className="flex gap-8 mb-8">
                <div>
                  <div className="text-4xl font-bold text-amber-500 mb-1">50+</div>
                  <div className="text-sm text-amber-100">Styles Available</div>
                </div>
                <div>
                  <div className="text-4xl font-bold text-amber-500 mb-1">24hrs</div>
                  <div className="text-sm text-amber-100">Ships Within</div>
                </div>
              </div>
              <Link
                to="/products"
                className="inline-flex items-center px-8 py-4 bg-amber-500 text-emerald-900 rounded-full font-medium text-lg hover:bg-amber-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                View Collection <i className="ri-shopping-bag-line ml-2"></i>
              </Link>
            </div>

            <div className="lg:col-span-3 relative">
              <div className="overflow-hidden" ref={carouselRef}>
                <div
                  className="flex gap-6 transition-transform duration-500 ease-in-out"
                  style={{ transform: `translateX(calc(-${carouselIndex} * (33.333% + 1.5rem)))` }}
                >
                  {readyToShip.map(item => (
                    <div key={item.id} className="flex-shrink-0 w-1/3 cursor-pointer group" data-product-shop="true">
                      <div className="bg-amber-50 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                        <div className="aspect-[3/4] overflow-hidden relative">
                          <img
                            alt={item.name}
                            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                            src={item.image}
                          />
                          <div className="absolute top-3 right-3">
                            <span className="px-3 py-1 bg-amber-500 text-amber-950 text-xs font-medium rounded-full">In Stock</span>
                          </div>
                        </div>
                        <div className="p-4 bg-gradient-to-t from-emerald-900/90 to-emerald-900/70 -mt-20 relative z-10">
                          <h3 className="text-base font-medium text-amber-50 mb-2">{item.name}</h3>
                          <p className="text-2xl font-bold text-amber-400 mb-3">{item.price}</p>
                          <button className="w-full py-2 border-2 border-amber-500 text-amber-100 rounded-full font-medium hover:bg-amber-500 hover:text-emerald-900 transition-all whitespace-nowrap cursor-pointer">
                            Quick Add
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <button
                onClick={prevSlide}
                disabled={carouselIndex === 0}
                className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 bg-amber-500 text-emerald-900 rounded-full flex items-center justify-center hover:bg-amber-400 transition-all shadow-lg cursor-pointer z-10 disabled:opacity-40"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <button
                onClick={nextSlide}
                disabled={carouselIndex >= maxIndex}
                className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 bg-amber-500 text-emerald-900 rounded-full flex items-center justify-center hover:bg-amber-400 transition-all shadow-lg cursor-pointer z-10 disabled:opacity-40"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ── OUR STORY ── */}
      <section className="py-20 px-6 md:px-12 lg:px-20 bg-amber-50 relative overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-amber-500 via-emerald-700 to-amber-500"></div>
        <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-r from-amber-500 via-emerald-700 to-amber-500"></div>
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img
                  alt="Artisan Craftsmanship"
                  className="w-full h-full object-cover object-top"
                  src="https://readdy.ai/api/search-image?query=skilled%20artisan%20hands%20carefully%20crafting%20traditional%20islamic%20embroidery%20on%20luxurious%20abaya%20fabric%20close%20up%20photography%20showing%20detailed%20needlework%20and%20gold%20thread%20warm%20natural%20lighting%20emphasizing%20craftsmanship%20and%20dedication%20cultural%20heritage%20professional%20documentary%20style%20photography&width=800&height=900&seq=story001&orientation=portrait"
                />
              </div>
              <div className="absolute top-6 left-6 bg-white rounded-2xl px-6 py-3 shadow-lg">
                <span className="text-amber-600 font-medium">Our Heritage</span>
              </div>
            </div>
            <div>
              <h2 className="font-serif text-4xl md:text-5xl text-emerald-900 mb-6 leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Crafted with Love,<br />Rooted in Tradition
              </h2>
              <div className="space-y-6 text-gray-700 leading-relaxed text-base">
                <p>
                  At SheWearHouse, we believe that modest fashion is not just about covering—it's about celebrating the beauty of Islamic culture through exquisite craftsmanship and timeless design. Every Abaya, every bangle, and every bead tells a story of heritage, artistry, and devotion.
                </p>
                <p>
                  Our journey began with a simple vision: to create elegant, high-quality modest wear that empowers Muslim women and girls to express their faith with confidence and grace. Each piece in our collection is thoughtfully designed and handcrafted by skilled artisans who pour their hearts into every stitch and detail.
                </p>
                <p>
                  From the flowing silhouettes of our signature Abayas to the intricate patterns of our handcrafted bangles, we honor traditional techniques while embracing modern aesthetics.
                </p>
              </div>
              <div className="mt-8">
                <Link
                  to="/about"
                  className="inline-flex items-center px-8 py-4 bg-amber-500 text-emerald-900 rounded-full font-medium text-lg hover:bg-amber-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Read Our Full Story <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="mt-16 bg-gradient-to-r from-amber-100 to-amber-50 rounded-2xl p-8 shadow-lg">
            <div className="max-w-4xl mx-auto text-center">
              <div className="flex justify-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-500 text-xl"></i>
                ))}
              </div>
              <p className="text-xl italic text-emerald-900 mb-4 font-serif">
                "The quality and attention to detail in every piece from SheWearHouse is absolutely stunning. I feel elegant and confident wearing their Abayas. This is more than clothing—it's art that honors our culture."
              </p>
              <p className="font-medium text-gray-700">— Amina Rahman, <span className="text-gray-600">Loyal Customer</span></p>
            </div>
          </div>
        </div>
      </section>

      {/* ── STAY CONNECTED ── */}
      <section className="py-20 px-6 md:px-12 lg:px-20 bg-gradient-to-br from-emerald-900 via-emerald-800 to-emerald-900">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-serif text-4xl md:text-5xl text-amber-50 mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Stay Connected
          </h2>
          <p className="text-lg text-amber-200 mb-8 max-w-2xl mx-auto">
            Subscribe to receive exclusive offers, new arrival updates, and styling inspiration delivered straight to your inbox.
          </p>
          {newsletterStatus === 'success' ? (
            <div className="max-w-md mx-auto mb-6 p-4 bg-amber-500/20 border border-amber-400 rounded-full text-amber-200 font-medium">
              <i className="ri-checkbox-circle-line mr-2"></i> Thank you for subscribing!
            </div>
          ) : (
            <form
              id="newsletter-form"
              className="max-w-md mx-auto mb-6"
              data-readdy-form="true"
              onSubmit={handleNewsletter}
            >
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  placeholder="Enter your email address"
                  className="flex-1 px-6 py-4 rounded-full bg-amber-50 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm"
                  required
                  type="email"
                  name="email"
                  value={newsletterEmail}
                  onChange={e => setNewsletterEmail(e.target.value)}
                />
                <button
                  type="submit"
                  className="px-8 py-4 bg-amber-500 text-emerald-900 rounded-full font-medium hover:bg-amber-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Subscribe
                </button>
              </div>
              {newsletterStatus === 'error' && (
                <p className="text-red-300 text-sm mt-2">Something went wrong. Please try again.</p>
              )}
            </form>
          )}
          <p className="text-sm text-amber-300">We respect your privacy. Unsubscribe at any time.</p>
        </div>
      </section>

      {/* ── COMMUNITY FLYER ── */}
      <section className="py-14 px-6 md:px-12 lg:px-20 bg-amber-50">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-r from-emerald-900 to-emerald-800 rounded-3xl overflow-hidden shadow-xl">
            <div className="flex flex-col md:flex-row items-center gap-8 px-10 py-10">
              {/* Icon */}
              <div className="flex-shrink-0 w-20 h-20 flex items-center justify-center bg-amber-500/20 border-2 border-amber-500/40 rounded-2xl">
                <i className="ri-file-download-line text-amber-400 text-4xl"></i>
              </div>
              {/* Text */}
              <div className="flex-1 text-center md:text-left">
                <div className="text-amber-400 text-xs font-medium tracking-widest uppercase mb-2">Community Events</div>
                <h3 className="font-serif text-2xl md:text-3xl text-amber-50 mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  Download Our Event Flyer
                </h3>
                <p className="text-amber-200 text-sm max-w-xl">
                  Share our 4-page community flyer featuring our full collection — Signature Abayas, Girls' Wear, Accessories, and exclusive event discount codes. Perfect for community events and clothing sales.
                </p>
              </div>
              {/* Button */}
              <div className="flex-shrink-0 flex flex-col items-center gap-3">
                <Link
                  to="/flyer"
                  className="inline-flex items-center gap-2 px-8 py-4 bg-amber-500 text-emerald-900 rounded-full font-semibold text-base hover:bg-amber-400 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-download-line text-lg"></i>
                  View &amp; Download Flyer
                </Link>
                <span className="text-amber-300 text-xs">Print-ready · 4 pages · PDF</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
